import { authenticatedFetch } from "./apiClient";

export interface JobCreationRequest {
  url: string;
  domain_id: string;
  page_id: string;
}

export interface JobCreationResponse {
  success: boolean;
  message: string;
  job_id: string;
}

export class JobGenerationService {
  static async startHeuristicJob(
    request: JobCreationRequest,
  ): Promise<JobCreationResponse> {
    const response = await authenticatedFetch(
      `${import.meta.env.VITE_API_URL}/v3/jobs/heuristic`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
      },
    );

    if (!response.ok) {
      throw new Error(`Job creation failed: ${response.statusText}`);
    }

    return response.json();
  }
}
